import {Component, inject}             from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {DialogWrapperComponent}        from '../dialog-wrapper/dialog-wrapper.component';

export interface DialogConfirmDataIntf {
	title: string;
	message: string;
}


@Component({
			   selector   : 'app-dialog-confirm',
			   imports    : [
				   DialogWrapperComponent
			   ],
			   templateUrl: './dialog-confirm.component.html',
			   styleUrl   : './dialog-confirm.component.css'
		   })
export class DialogConfirmComponent {
	public dialogRef: MatDialogRef<DialogConfirmComponent, boolean> = inject(MatDialogRef);
	public data: DialogConfirmDataIntf = inject(MAT_DIALOG_DATA)

	onConfirm(): void {
		this.dialogRef.close(true);
	}

	onCancel(): void {
		this.dialogRef.close(false);
	}

}
